export default __webpack_public_path__ + "static/media/menu_btn_mobile.ab9d0a3f.svg";